import Vue from 'vue';

Vue.mixin({
  methods: {
    async login(data) {
      const loader = this.$loading.show();

      try {
        const response = await this.axios.post('login', data);

        if (response.data.success) {
          const user = response.data.data;

          if (this.remember) {
            localStorage.setItem('user', JSON.stringify(user));
          }

          this.$store.dispatch('SET_USER', user);
          this.$store.dispatch('INIT_FAVORITES');
          this.$store.dispatch('INIT_CUSTOMER_ITEMS', true);

          this.$router.push(
              this.i18nLink(this.checkout && this.checkout.authType === 'user'
                  ? 'checkout' : '/'));
        } else if (response.data.errors.length > 0
            && typeof this.validation !== 'undefined') {
          response.data.errors.forEach((error) => {
            if (typeof this.validation[error.field] !== 'undefined') {
              this.validation[error.field].valid = false;
              this.validation[error.field].message = error.message;
            }
          });
        } else if (response.data.message !== '') {
          this.toast(this.$t('error'), response.data.message, 'danger');
        }
        loader.hide();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        loader.hide();
      }
    },
    async updateProfile(data) {
      const loader = this.$loading.show();

      try {
        const response = await this.axios.post('customers/update_profile',
            data);

        if (response.data.success) {
          const user = response.data.data;

          if (localStorage.getItem('user')) {
            localStorage.setItem('user', JSON.stringify(user));
          }

          this.$store.dispatch('SET_USER', user);
          this.toast(this.$t('success'), response.data.message);
        } else if (response.data.errors.length > 0
            && typeof this.validation !== 'undefined') {
          response.data.errors.forEach((error) => {
            if (typeof this.validation[error.field] !== 'undefined') {
              this.validation[error.field].valid = false;
              this.validation[error.field].message = error.message;
            }
          });
        } else if (response.data.message !== '') {
          this.toast(this.$t('error'), response.data.message, 'danger');
        }
        loader.hide();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        loader.hide();
      }
    },
    async changePassword(data) {
      const loader = this.$loading.show();

      try {
        const response = await this.axios.post('customers/change_password',
            data);
        this.initForm();

        if (response.data.success) {
          this.toast(this.$t('success'), response.data.message);
        } else if (response.data.errors.length > 0
            && typeof this.validation !== 'undefined') {
          response.data.errors.forEach((error) => {
            if (typeof this.validation[error.field] !== 'undefined') {
              this.validation[error.field].valid = false;
              this.validation[error.field].message = error.message;
            }
          });
        } else if (response.data.message !== '') {
          this.toast(this.$t('error'), response.data.message, 'danger');
        }
        loader.hide();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);

        this.initForm();
        loader.hide();
      }
    },
    async updateDeliveryAddress(data) {
      const loader = this.$loading.show();

      try {
        const response = await this.axios.post(
            'customers/update_delivery_address', data);

        if (response.data.success) {
          const user = response.data.data;

          if (localStorage.getItem('user')) {
            localStorage.setItem('user', JSON.stringify(user));
          }

          this.$store.dispatch('SET_USER', user);
          this.toast(this.$t('success'), response.data.message);
        } else if (response.data.errors.length > 0
            && typeof this.validation !== 'undefined') {
          response.data.errors.forEach((error) => {
            if (typeof this.validation[error.field] !== 'undefined') {
              this.validation[error.field].valid = false;
              this.validation[error.field].message = error.message;
            }
          });
        } else if (response.data.message !== '') {
          this.toast(this.$t('error'), response.data.message, 'danger');
        }
        loader.hide();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        loader.hide();
      }
    },
    async checkPassword(data) {
      this.loader = true;

      try {
        const response = await this.axios.post(
            'customers/check_password', data);

        if (typeof this.form !== 'undefined') {
          this.form.password = '';
        }

        if (response.data.success) {
          this.logout();
        } else if (response.data.errors.length > 0
            && typeof this.validation !== 'undefined') {
          response.data.errors.forEach((error) => {
            if (typeof this.validation[error.field] !== 'undefined') {
              this.validation[error.field].valid = false;
              this.validation[error.field].message = error.message;
            }
          });
        } else if (response.data.message !== '') {
          this.toast(this.$t('error'), response.data.message, 'danger');
        }
        this.loader = false;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        this.loader = false;
        this.form.password = '';
      }
    },
    logout() {
      this.$store.dispatch('CLEAR_CART');
      this.$store.dispatch('SET_USER', null);
      localStorage.removeItem('user');

      this.axios.interceptors.request.use(config => {
        config.headers['X-Auth-Token'] = '';
        return config;
      });

      if (this.$route.name !== 'home') {
        this.$router.push(this.i18nLink('/'));
      }
    },
  },
});

